module.exports = __webpack_public_path__ + "static/19invgde-38d1fbc10b5e55b4b4804d0751c63503.gif";